import TabNav from './tab-nav'

export default TabNav
